import globalApi from "../../app/GlobalApi";






const tasksApi = globalApi.injectEndpoints({
  endpoints: (builder) => ({

    getTasks: builder.query({

      query: () => ({
        url: `/tasks`,
        method: 'GET',
      }),



    }),
    getTask: builder.query({

      query: (id) => ({
        url: `/tasks/${id}`,
        method: 'GET',
      }),



    }),
    postTask: builder.mutation({

      query: (data) => ({
        url: `/tasks`,
        method: 'POST',
        body: data
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {


        try {
          const task = await queryFulfilled;
        
        if(task?.data?.id){
          dispatch(
            globalApi.util.updateQueryData(
              "getTasks", undefined,
              (draft) => {
               draft.push(arg)
              }
            ))
        }

        } catch (err) {
      
        }
      },


    }),
    updateTask: builder.mutation({

      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: 'PATCH',
        body: data
      }),


      async onQueryStarted(arg, { queryFulfilled, dispatch }) {


        // optimistic cache update start
        const pathResult = dispatch(
          globalApi.util.updateQueryData(
            "getTasks", undefined,
            (draft) => {

              const draftTask = draft.find(
                (c) => c.id == arg.id
              );
             
              draftTask.status = arg.data.status || 'pending';
              draftTask.id = arg.data.id;
              draftTask.taskName = arg.data.taskName;
              draftTask.project = arg.data.project;
              draftTask.deadline = arg.data.deadline;
             
            }
          )
        );
        // optimistic cache update end
        try {
          const conversation = await queryFulfilled;
          console.log('conversation', conversation)

        } catch (err) {
          pathResult.undo();
        }
      },


    }),


    deleteTask: builder.mutation({

      query: (id) => ({
        url: `/tasks/${id}`,
        method: 'DELETE',
      }),


      async onQueryStarted(arg, { queryFulfilled, dispatch }) {


        // optimistic cache update start
        const deleteResult = dispatch(
          globalApi.util.updateQueryData(
            "getTasks", undefined,
            (draft) => {
           
              draft.splice(draft.findIndex(t=>t.id==arg),1);
          

            }
          )
        );
        // optimistic cache update end
        try {
          const conversation = await queryFulfilled;

        } catch (err) {
          deleteResult.undo();
        }
      },

    })
  })

})
export const { useGetTasksQuery, useDeleteTaskMutation, usePostTaskMutation, useUpdateTaskMutation ,useGetTaskQuery} = tasksApi;
